import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35930564"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offcanvas-header border-bottom py-0" }
const _hoisted_2 = { class: "left d-flex align-items-center" }
const _hoisted_3 = { class: "offcanvas-title me-5" }
const _hoisted_4 = { class: "right d-flex justify-content-end align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "refresh", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "offcanvas-body" }
const _hoisted_9 = {
  key: 0,
  class: "product row gx-3"
}
const _hoisted_10 = { class: "left col-2 col-xl-3" }
const _hoisted_11 = { class: "image border rounded mb-3" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "image border rounded mb-3"
}
const _hoisted_14 = { class: "px-2" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = { class: "px-1" }
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-auto" }
const _hoisted_22 = { class: "px-1" }
const _hoisted_23 = { class: "col-auto" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "text-bg-light rounded px-3 py-2 mb-2" }
const _hoisted_26 = { class: "right col-10 col-xl-9" }
const _hoisted_27 = { class: "title mb-4" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "cnk-code text-bg-light rounded p-2 mb-3" }
const _hoisted_31 = { class: "row align-items-center" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "fs-6 item-title me-5 mb-0" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "fs-5 mb-0" }
const _hoisted_36 = { class: "categories row align-items-start mb-2" }
const _hoisted_37 = { class: "d-flex justify-content-between" }
const _hoisted_38 = { class: "item-title" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "categories row align-items-start mb-2" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_44 = {
  key: 0,
  class: "dp-managed-category row align-items-start"
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-auto" }
const _hoisted_47 = { class: "internal-category row align-items-start mb-2 mt-2" }
const _hoisted_48 = { class: "d-flex justify-content-between" }
const _hoisted_49 = { class: "item-title" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 0,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-auto" }
const _hoisted_55 = { class: "categories row align-items-start mb-2" }
const _hoisted_56 = { class: "col-auto" }
const _hoisted_57 = { class: "col" }
const _hoisted_58 = { class: "apb-category row align-items-start mb-2" }
const _hoisted_59 = { class: "col item-title" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = { class: "apb-legal-category row align-items-start mb-2" }
const _hoisted_62 = { class: "col item-title" }
const _hoisted_63 = { class: "col" }
const _hoisted_64 = { class: "farmaline-category row align-items-start" }
const _hoisted_65 = { class: "col item-title" }
const _hoisted_66 = { class: "col" }
const _hoisted_67 = { class: "fs-5 mb-0" }
const _hoisted_68 = { class: "usage row align-items-center" }
const _hoisted_69 = { class: "col item-title" }
const _hoisted_70 = { class: "col" }
const _hoisted_71 = { class: "active-substances row align-items-center" }
const _hoisted_72 = { class: "col item-title" }
const _hoisted_73 = { class: "col" }
const _hoisted_74 = { class: "col" }
const _hoisted_75 = { class: "price text-bg-light rounded px-2 py-1 mb-3" }
const _hoisted_76 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = { class: "fs-6 item-title me-4 mb-0" }
const _hoisted_79 = { class: "m-0" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "history", -1))
const _hoisted_81 = { class: "fs-5 mb-0" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "info", -1))
const _hoisted_83 = { class: "brand row align-items-center" }
const _hoisted_84 = { class: "col item-title" }
const _hoisted_85 = { class: "col" }
const _hoisted_86 = { class: "fs-5 mb-0" }
const _hoisted_87 = { class: "leaflet row align-items-center" }
const _hoisted_88 = { class: "col item-title" }
const _hoisted_89 = { class: "col" }
const _hoisted_90 = ["href"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fs-5 ms-1" }, "open_in_new", -1))
const _hoisted_92 = { class: "technical-leaflet row align-items-center" }
const _hoisted_93 = { class: "col item-title" }
const _hoisted_94 = { class: "col" }
const _hoisted_95 = ["href"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fs-5 ms-1" }, "open_in_new", -1))
const _hoisted_97 = { class: "fs-5 mb-0" }
const _hoisted_98 = { class: "col item-title" }
const _hoisted_99 = { class: "col" }
const _hoisted_100 = { class: "mas mas-fill-1 lh-1" }
const _hoisted_101 = { class: "fs-5 mb-0" }
const _hoisted_102 = { class: "desciption item-title" }
const _hoisted_103 = { class: "value" }
const _hoisted_104 = { class: "title mt-2 mb-4 d-flex justify-content-begin align-items-center" }
const _hoisted_105 = { class: "name fs-3 cu-p me-4 mb-0" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = {
  key: 1,
  class: "general-feedback mb-4"
}
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "col" }
const _hoisted_111 = { class: "fs-5 mb-0" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_115 = { class: "col item-title" }
const _hoisted_116 = { class: "col" }
const _hoisted_117 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_118 = { class: "col item-title" }
const _hoisted_119 = { class: "col" }
const _hoisted_120 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_121 = { class: "col item-title" }
const _hoisted_122 = { class: "col" }
const _hoisted_123 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_124 = { class: "col item-title" }
const _hoisted_125 = { class: "col" }
const _hoisted_126 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_127 = { class: "col item-title" }
const _hoisted_128 = { class: "col" }
const _hoisted_129 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_130 = { class: "col-5 item-title" }
const _hoisted_131 = { class: "col" }
const _hoisted_132 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_133 = { class: "col-5 item-title" }
const _hoisted_134 = { class: "col" }
const _hoisted_135 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_136 = { class: "col-5 item-title" }
const _hoisted_137 = { class: "col" }
const _hoisted_138 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_139 = { class: "col-5 item-title" }
const _hoisted_140 = { class: "col" }
const _hoisted_141 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_142 = { class: "col-5" }
const _hoisted_143 = { class: "row" }
const _hoisted_144 = { class: "col item-title" }
const _hoisted_145 = { class: "row" }
const _hoisted_146 = { class: "col" }
const _hoisted_147 = { class: "col" }
const _hoisted_148 = { class: "col" }
const _hoisted_149 = { class: "fs-5 mb-0" }
const _hoisted_150 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_151 = { class: "col item-title" }
const _hoisted_152 = { class: "col" }
const _hoisted_153 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_154 = { class: "col item-title" }
const _hoisted_155 = { class: "col" }
const _hoisted_156 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_157 = { class: "col item-title" }
const _hoisted_158 = { class: "col" }
const _hoisted_159 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_160 = { class: "col item-title" }
const _hoisted_161 = { class: "col" }
const _hoisted_162 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_163 = { class: "col item-title" }
const _hoisted_164 = { class: "col" }
const _hoisted_165 = { class: "row" }
const _hoisted_166 = { class: "col" }
const _hoisted_167 = { class: "fs-5 mb-0" }
const _hoisted_168 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_169 = { class: "desciption item-title" }
const _hoisted_170 = { class: "buttons d-flex justify-content-begin align-items-center" }
const _hoisted_171 = ["onClick"]
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_173 = [
  _hoisted_172
]
const _hoisted_174 = ["onClick"]
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_176 = [
  _hoisted_175
]
const _hoisted_177 = ["innerHTML"]
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1))
const _hoisted_179 = { key: 1 }
const _hoisted_180 = { class: "row" }
const _hoisted_181 = { class: "col" }
const _hoisted_182 = { class: "fs-5 mb-0" }
const _hoisted_183 = { class: "desciption item-title" }
const _hoisted_184 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_Lightbox = _resolveComponent("Lightbox")!
  const _component_PimProductsOverviewItemIcons = _resolveComponent("PimProductsOverviewItemIcons")!
  const _component_PimProductsOverviewLegend = _resolveComponent("PimProductsOverviewLegend")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_PimProductsDetailCategories = _resolveComponent("PimProductsDetailCategories")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_BaseModalButton = _resolveComponent("BaseModalButton")!
  const _component_PimFeedbackPanel = _resolveComponent("PimFeedbackPanel")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_BaseSubmittingOverlay = _resolveComponent("BaseSubmittingOverlay")!
  const _component_NamedTextFragmentPanel = _resolveComponent("NamedTextFragmentPanel")!
  const _component_PimProductsDetailPrices = _resolveComponent("PimProductsDetailPrices")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_PimProductsDetailLab = _resolveComponent("PimProductsDetailLab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t('pharmapim')), 1),
        _createVNode(_component_MultilingualSwitcher, {
          "active-language": _ctx.activeLanguage,
          languages: _ctx.languages,
          onUpdateActiveLanguage: _ctx.changeLanguage,
          errors: {},
          mb: 0
        }, null, 8, ["active-language", "languages", "onUpdateActiveLanguage"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-hover",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args)), ["prevent"]))
        }, _hoisted_6),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError(),
        class: "mb-3"
      }, null, 8, ["error"]),
      _createVNode(_component_base_spinner, {
        spin: _ctx.pageUI.isNotReady()
      }, null, 8, ["spin"]),
      (_ctx.pageUI.isReady())
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.product.product_info.main_image_url?.[_ctx.activeLanguage])
                  ? (_openBlock(), _createBlock(_component_Lightbox, {
                      key: 0,
                      sources: [_ctx.product.product_info.main_image_url?.[_ctx.activeLanguage]],
                      class: "btn"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.product.product_info.main_image_url?.[_ctx.activeLanguage],
                          alt: _ctx.product.product_info?.name,
                          class: "img-fluid"
                        }, null, 8, _hoisted_12)
                      ]),
                      _: 1
                    }, 8, ["sources"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.AbilityContext.isAuthorizedForFeature('FARMA_FRAME_API'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('farmaframeImages')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('nl')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_Lightbox, {
                          sources: [_ctx.farmaFrameThumbnailNl],
                          class: "btn"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.farmaFrameThumbnailNl,
                              alt: "FarmaFrame_nl",
                              class: "img-fluid"
                            }, null, 8, _hoisted_19)
                          ]),
                          _: 1
                        }, 8, ["sources"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('fr')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Lightbox, {
                          sources: [_ctx.farmaFrameThumbnailFr],
                          class: "btn"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.farmaFrameThumbnailFr,
                              alt: "FarmaFrame_fr",
                              class: "img-fluid"
                            }, null, 8, _hoisted_24)
                          ]),
                          _: 1
                        }, 8, ["sources"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_PimProductsOverviewItemIcons, { product: _ctx.product }, null, 8, ["product"])
              ]),
              _createVNode(_component_PimProductsOverviewLegend)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h2", {
                  class: "name fs-3 cu-p me-4 mb-0",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"]))
                }, _toDisplayString(_ctx.product.product_info?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t('cnk')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("p", {
                          class: "fs-6 cu-p mb-0",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"]))
                        }, _toDisplayString(_ctx.product.product_info?.cnk_code), 1)
                      ])
                    ])
                  ]),
                  _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.$t('categorization')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_GenericFormWrapper, {
                            pageUI: _ctx.dpCategoryUI,
                            submitData: _ctx.submitAddDPCategory,
                            hideButtons: !_ctx.isShowAddDpmanagedCategory
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('patientFriendlyCategoryDigitalPharma')), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-icon btn-primary ms-1",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowAddDpmanagedCategory = !_ctx.isShowAddDpmanagedCategory))
                                  }, _hoisted_40)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                (_ctx.product.categories)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.categories, (category) => {
                                        return (_openBlock(), _createBlock(_component_PimProductsDetailCategories, {
                                          key: category.code,
                                          "category-code": category.code,
                                          "category-path": category?.path_by_name?.[_ctx.activeLanguage],
                                          onRemoveDpCat: _ctx.removeDPCat,
                                          pageUI: _ctx.dpCategoryUI
                                        }, null, 8, ["category-code", "category-path", "onRemoveDpCat", "pageUI"]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                (_ctx.isShowAddDpmanagedCategory)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                          _createVNode(_component_SelectCategories, {
                                            "selected-product-categories": _ctx.dpManagedCategoryToAddCode ? [_ctx.dpManagedCategoryToAddCode] : [],
                                            "catalog-customer-code": _ctx.catalogCustomerCode,
                                            class: _normalizeClass(["mb-3", {'category-selected': _ctx.dpManagedCategoryToAddCode}]),
                                            "btn-class": "btn btn-icon btn-outline-primary w-100",
                                            "btn-icon": "category",
                                            onAddCategory: _cache[4] || (_cache[4] = (category_code) => _ctx.prepareAddCategory(category_code)),
                                            onRemoveCategory: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dpManagedCategoryToAddCode = null)),
                                            rules: "required"
                                          }, null, 8, ["selected-product-categories", "catalog-customer-code", "class"])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }, 8, ["pageUI", "submitData", "hideButtons"]),
                          _createVNode(_component_GenericFormWrapper, {
                            pageUI: _ctx.internalCategoryUI,
                            submitData: _ctx.submitAddInternalCategory,
                            hideButtons: !_ctx.isShowAddInternalCategory,
                            class: "mt-2"
                          }, {
                            content: _withCtx(({errors}) => [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('internalCategory')), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-icon btn-primary ms-1",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowAddInternalCategory = !_ctx.isShowAddInternalCategory))
                                  }, _hoisted_51)
                                ])
                              ]),
                              (_ctx.isShowAddInternalCategory)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createVNode(_component_input_select, {
                                          modelValue: _ctx.internalCategoryToAddCode,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.internalCategoryToAddCode) = $event)),
                                          name: "internalCategoryToAddCode",
                                          selectText: _ctx.$t('selectText'),
                                          options: _ctx.internalProductCategories,
                                          errors: errors,
                                          rules: "required",
                                          class: "mb-3",
                                          onChange: _ctx.prepareAddInternalCategory
                                        }, null, 8, ["modelValue", "selectText", "options", "errors", "onChange"])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_55, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.internal_categories, (category) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: category.code,
                                    class: "row mb-2"
                                  }, [
                                    _createElementVNode("div", _hoisted_56, _toDisplayString(category.description), 1),
                                    _createElementVNode("div", _hoisted_57, [
                                      _createVNode(_component_BaseDeleteButton, {
                                        deleteData: () => _ctx.removeIntCat(category.code),
                                        pageUI: _ctx.internalCategoryUI,
                                        itemKey: category.code,
                                        class: "btn-small"
                                      }, null, 8, ["deleteData", "pageUI", "itemKey"])
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('apbCategory')), 1),
                                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.product?.category_apb?.description), 1)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('apbLegalCategory')), 1),
                                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.product?.category_apb_legal?.description), 1)
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('farmalineCategory')), 1),
                                _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.product?.category_farmaline?.description), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["pageUI", "submitData", "hideButtons"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseCard, { class: "general text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_67, _toDisplayString(_ctx.$t('general')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('usage')), 1),
                            _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.product.product_info?.usage?.description), 1)
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('activeSubstances')), 1),
                            _createElementVNode("div", _hoisted_73, _toDisplayString(), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("h3", _hoisted_78, _toDisplayString(_ctx.$t('publicPrice')), 1),
                        _createElementVNode("p", _hoisted_79, " € " + _toDisplayString(_ctx.product.product_info?.product_price?.standard_price_with_vat?.toFixed(2)) + " (" + _toDisplayString(_ctx.$t('inclVat', {percentage: _ctx.product.product_info?.product_price?.vat_percentage})) + ") ", 1)
                      ]),
                      _createVNode(_component_BaseModalButton, {
                        "modal-id": _ctx.modalPriceHistoryId,
                        class: "btn btn-sm btn-toggle p-0"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_80
                        ]),
                        _: 1
                      }, 8, ["modal-id"])
                    ])
                  ]),
                  _createVNode(_component_BaseCard, { class: "producer text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "px-2 py-1" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_81, _toDisplayString(_ctx.$t('supplier')), 1),
                          _createVNode(_component_BaseModalButton, {
                            "modal-id": _ctx.modalProducerInfoId,
                            class: "btn btn-sm btn-toggle p-0"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_82
                            ]),
                            _: 1
                          }, 8, ["modal-id"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('brand')), 1),
                            _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.product.product_info?.brand?.description), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseCard, { class: "leaflets text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_86, _toDisplayString(_ctx.$t('leaflets')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('patientLeaflet')), 1),
                            _createElementVNode("div", _hoisted_89, [
                              (_ctx.product?.leaflet_info?.leaflet_url?.[_ctx.activeLanguage])
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _ctx.product.leaflet_info.leaflet_url?.[_ctx.activeLanguage],
                                    target: "_blank",
                                    class: "btn btn-sm btn-icon btn-toggle justify-content-start"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('open')) + " ", 1),
                                    _hoisted_91,
                                    _createElementVNode("i", {
                                      class: "mas fs-5 ms-1",
                                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyToClipboard(_ctx.product.leaflet_info.leaflet_url?.[_ctx.activeLanguage])), ["prevent"]))
                                    }, "content_copy")
                                  ], 8, _hoisted_90))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t('scientificLeaflet')), 1),
                            _createElementVNode("div", _hoisted_94, [
                              (_ctx.product?.leaflet_info?.technical_leaflet_url?.[_ctx.activeLanguage])
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _ctx.product.leaflet_info.technical_leaflet_url?.[_ctx.activeLanguage],
                                    target: "_blank",
                                    class: "btn btn-sm btn-icon btn-toggle justify-content-start"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('open')) + " ", 1),
                                    _hoisted_96,
                                    _createElementVNode("i", {
                                      class: "mas fs-5 ms-1",
                                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyToClipboard(_ctx.product.leaflet_info.technical_leaflet_url?.[_ctx.activeLanguage])), ["prevent"]))
                                    }, "content_copy")
                                  ], 8, _hoisted_95))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseCard, { class: "wholesaler text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_97, _toDisplayString(_ctx.$t('wholesalers')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.wholesaler_availabilities, (wholesaler_availability) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: wholesaler_availability.wholesaler.code,
                              class: _normalizeClass([wholesaler_availability.wholesaler.code, "row align-items-center"])
                            }, [
                              _createElementVNode("div", _hoisted_98, _toDisplayString(wholesaler_availability.wholesaler.description), 1),
                              _createElementVNode("div", _hoisted_99, [
                                _createElementVNode("i", _hoisted_100, _toDisplayString(wholesaler_availability.is_available ? 'check' : 'close'), 1)
                              ])
                            ], 2))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.hasProductProperties)
                ? (_openBlock(), _createBlock(_component_BaseCard, {
                    key: 0,
                    class: "properties text-bg-light border-light"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_101, _toDisplayString(_ctx.$t('productInformation')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.product_properties, (product_property) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: product_property,
                              class: "mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_102, _toDisplayString(product_property?.type?.description), 1),
                              _createElementVNode("div", _hoisted_103, _toDisplayString(product_property?.value), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("h3", _hoisted_105, _toDisplayString(_ctx.$t('licensedContent')), 1),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-icon btn-primary ms-1",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.isShowGeneralFeedback = !_ctx.isShowGeneralFeedback), ["prevent"]))
                }, _hoisted_107)
              ]),
              (_ctx.isShowGeneralFeedback)
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createVNode(_component_PimFeedbackPanel, {
                      "is-general-remark": true,
                      pageUI: _ctx.pimFeedbackUI,
                      onSubmitPimFeedback: _ctx.submitPimFeedback,
                      onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                    }, null, 8, ["pageUI", "onSubmitPimFeedback", "onSubmitPimFeedbackCancel"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_111, _toDisplayString(_ctx.$t('structuredProperties')), 1),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-icon btn-primary ms-1",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleEditCorePimDetails && _ctx.toggleEditCorePimDetails(...args)))
                          }, _hoisted_113)
                        ]),
                        _: 1
                      }),
                      (!_ctx.isCorePimDetailsEditMode)
                        ? (_openBlock(), _createBlock(_component_BaseCardBody, {
                            key: 0,
                            class: "p-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t('commercialName')), 1),
                                _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.productInfo?.details?.commercial_name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.$t('trademark')), 1),
                                _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.productInfo?.details?.trademark?.description), 1)
                              ]),
                              _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.$t('targetGroup')), 1),
                                _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.productInfo?.details?.target_group?.description), 1)
                              ]),
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.$t('unit')), 1),
                                _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.productInfo?.details?.unit?.description), 1)
                              ]),
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("div", _hoisted_127, _toDisplayString(_ctx.$t('shape')), 1),
                                _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.productInfo?.details?.shape), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isCorePimDetailsEditMode)
                        ? (_openBlock(), _createBlock(_component_BaseCardBody, {
                            key: 1,
                            class: "p-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_GenericFormWrapper, {
                                pageUI: _ctx.pimCoreDataUI,
                                submitData: _ctx.submitPimCoreData
                              }, {
                                content: _withCtx(({errors}) => [
                                  _createElementVNode("div", _hoisted_129, [
                                    _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.$t('commercialName')), 1),
                                    _createElementVNode("div", _hoisted_131, [
                                      _createVNode(_component_input_text, {
                                        modelValue: _ctx.corePimDetailsDto.commercial_name,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.corePimDetailsDto.commercial_name) = $event)),
                                        name: 'pim_details.commercial_name',
                                        mode: "default",
                                        errors: errors,
                                        onChange: _ctx.pimCoreDataChanged
                                      }, null, 8, ["modelValue", "name", "errors", "onChange"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.$t('trademark')), 1),
                                    _createElementVNode("div", _hoisted_134, [
                                      _createVNode(_component_input_select, {
                                        modelValue: _ctx.corePimDetailsDto.trademark_code,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.corePimDetailsDto.trademark_code) = $event)),
                                        name: 'pim_details.trademark_code',
                                        selectText: _ctx.$t('selectText'),
                                        options: _ctx.trademarkOptions,
                                        errors: errors,
                                        "can-clear": "",
                                        class: "mb-3",
                                        onChange: _ctx.pimCoreDataChanged
                                      }, null, 8, ["modelValue", "name", "selectText", "options", "errors", "onChange"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_135, [
                                    _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.$t('targetGroup')), 1),
                                    _createElementVNode("div", _hoisted_137, [
                                      _createVNode(_component_input_select, {
                                        modelValue: _ctx.corePimDetailsDto.target_group_code,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.corePimDetailsDto.target_group_code) = $event)),
                                        name: 'pim_details.target_group_code',
                                        selectText: _ctx.$t('selectText'),
                                        options: _ctx.targetGroupOptions,
                                        errors: errors,
                                        "can-clear": "",
                                        class: "mb-3",
                                        onChange: _ctx.pimCoreDataChanged
                                      }, null, 8, ["modelValue", "name", "selectText", "options", "errors", "onChange"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_138, [
                                    _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.$t('unit')), 1),
                                    _createElementVNode("div", _hoisted_140, [
                                      _createVNode(_component_input_select, {
                                        modelValue: _ctx.corePimDetailsDto.unit_code,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.corePimDetailsDto.unit_code) = $event)),
                                        name: 'pim_details.unit_code',
                                        selectText: _ctx.$t('selectText'),
                                        options: _ctx.unitOptions,
                                        errors: errors,
                                        "can-clear": "",
                                        class: "mb-3",
                                        onChange: _ctx.pimCoreDataChanged
                                      }, null, 8, ["modelValue", "name", "selectText", "options", "errors", "onChange"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("div", _hoisted_142, [
                                      _createElementVNode("div", _hoisted_143, [
                                        _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.$t('shape')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_145, [
                                        _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.$t('shapeExamples')), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_147, [
                                      _createVNode(_component_input_text, {
                                        modelValue: _ctx.corePimDetailsDto.shape,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.corePimDetailsDto.shape) = $event)),
                                        name: 'pim_details.shape',
                                        mode: "default",
                                        errors: errors,
                                        onChange: _ctx.pimCoreDataChanged
                                      }, null, 8, ["modelValue", "name", "errors", "onChange"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["pageUI", "submitData"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_148, [
                  _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_149, _toDisplayString(_ctx.$t('dimensions')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_150, [
                                _createElementVNode("div", _hoisted_151, _toDisplayString(_ctx.$t('width')), 1),
                                _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.productInfo?.details?.width), 1)
                              ]),
                              _createElementVNode("div", _hoisted_153, [
                                _createElementVNode("div", _hoisted_154, _toDisplayString(_ctx.$t('height')), 1),
                                _createElementVNode("div", _hoisted_155, _toDisplayString(_ctx.productInfo?.details?.height), 1)
                              ]),
                              _createElementVNode("div", _hoisted_156, [
                                _createElementVNode("div", _hoisted_157, _toDisplayString(_ctx.$t('depth')), 1),
                                _createElementVNode("div", _hoisted_158, _toDisplayString(_ctx.productInfo?.details?.height), 1)
                              ]),
                              _createElementVNode("div", _hoisted_159, [
                                _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.$t('weight')), 1),
                                _createElementVNode("div", _hoisted_161, _toDisplayString(_ctx.productInfo?.details?.weight), 1)
                              ]),
                              _createElementVNode("div", _hoisted_162, [
                                _createElementVNode("div", _hoisted_163, _toDisplayString(_ctx.$t('volume')), 1),
                                _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.productInfo?.details?.volume), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("div", _hoisted_166, [
                  _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_167, _toDisplayString(_ctx.$t('structuredTextFragments')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BaseSubmittingOverlay, {
                                "is-submitting": _ctx.namedFragmentUI.isSubmitting() ||  _ctx.namedFragmentUI.isAnyItemDeleting()
                              }, null, 8, ["is-submitting"]),
                              _createVNode(_component_AlertError2, {
                                error: _ctx.namedFragmentUI.getError()
                              }, null, 8, ["error"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.named_text_fragments, (fragment) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: fragment,
                                  class: "mb-3"
                                }, [
                                  _createElementVNode("div", _hoisted_168, [
                                    _createElementVNode("div", _hoisted_169, _toDisplayString(fragment.text_fragment?.fragment?.title), 1),
                                    _createElementVNode("div", _hoisted_170, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-icon btn-primary ms-1",
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleIsShowFeedbackForFragmentWithId(fragment.id)), ["prevent"])
                                      }, _hoisted_173, 8, _hoisted_171),
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-icon btn-primary ms-1",
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleIsEditingNamedTextFragmentWithId(fragment.id)), ["prevent"])
                                      }, _hoisted_176, 8, _hoisted_174),
                                      _createVNode(_component_BaseDeleteButton, {
                                        "delete-data": () => _ctx.deleteFragment(fragment.id),
                                        pageUI: _ctx.namedFragmentUI,
                                        itemKey: fragment.id,
                                        class: "ms-1 btn-sm"
                                      }, null, 8, ["delete-data", "pageUI", "itemKey"])
                                    ])
                                  ]),
                                  (_ctx.isEditingNamedTextFragmentWithId === fragment?.id)
                                    ? (_openBlock(), _createBlock(_component_NamedTextFragmentPanel, {
                                        key: 0,
                                        "named-text-fragment": fragment,
                                        pageUI: _ctx.namedFragmentUI,
                                        onSubmitNamedFragmentContent: _ctx.submitNamedFragmentContent,
                                        onSubmitNamedFragmentCancel: _ctx.submitNamedFragmentCancel
                                      }, null, 8, ["named-text-fragment", "pageUI", "onSubmitNamedFragmentContent", "onSubmitNamedFragmentCancel"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isShowFeedbackForFragmentWithId === fragment?.id)
                                    ? (_openBlock(), _createBlock(_component_PimFeedbackPanel, {
                                        key: 1,
                                        "is-general-remark": false,
                                        "field-code": fragment.text_fragment.code,
                                        "text-fragment-id": fragment.id,
                                        onSubmitPimFeedback: _ctx.submitPimFeedback,
                                        onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel,
                                        pageUI: _ctx.pimFeedbackUI
                                      }, null, 8, ["field-code", "text-fragment-id", "onSubmitPimFeedback", "onSubmitPimFeedbackCancel", "pageUI"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    innerHTML: fragment?.text_fragment?.fragment?.content,
                                    class: "value"
                                  }, null, 8, _hoisted_177)
                                ]))
                              }), 128)),
                              _createElementVNode("div", null, [
                                (! _ctx.isNewNamedTextFragmentPanelOpen)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openNewNamedTextFragmentPanel && _ctx.openNewNamedTextFragmentPanel(...args)), ["prevent"])),
                                      class: "btn btn-sm btn-icon btn-primary d-flex align-items-center"
                                    }, [
                                      _hoisted_178,
                                      _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isNewNamedTextFragmentPanelOpen)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      (_ctx.isNewNamedTextFragmentPanelOpen)
                                        ? (_openBlock(), _createBlock(_component_NamedTextFragmentPanel, {
                                            key: 0,
                                            pageUI: _ctx.namedFragmentUI,
                                            onSubmitNamedFragmentContent: _ctx.submitNamedFragmentContent,
                                            onSubmitNamedFragmentCancel: _ctx.submitNamedFragmentCancel
                                          }, null, 8, ["pageUI", "onSubmitNamedFragmentContent", "onSubmitNamedFragmentCancel"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("div", _hoisted_181, [
                  _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_182, _toDisplayString(_ctx.$t('freeTextFragments')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.text_fragments, (fragment) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: fragment,
                                  class: "mb-3"
                                }, [
                                  _createElementVNode("div", _hoisted_183, _toDisplayString(fragment?.text_fragment?.title), 1),
                                  _createElementVNode("div", {
                                    innerHTML: fragment?.text_fragment?.content,
                                    class: "value"
                                  }, null, 8, _hoisted_184)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_BaseModal, {
      "modal-id": _ctx.modalPriceHistoryId,
      title: "Prijsgeschiedenis",
      "dialog-classes": "modal-xl",
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PimProductsDetailPrices, { "cnk-code": _ctx.cnkCode }, null, 8, ["cnk-code"])
      ]),
      _: 1
    }, 8, ["modal-id"]),
    (_ctx.product?.producent_detail_info)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 0,
          "modal-id": _ctx.modalProducerInfoId,
          title: _ctx.product.product_info?.brand?.description ?? 'Producent info',
          "no-footer": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PimProductsDetailLab, {
              product: _ctx.product,
              "cnk-code": _ctx.cnkCode
            }, null, 8, ["product", "cnk-code"])
          ]),
          _: 1
        }, 8, ["modal-id", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}